import React from 'react';

const AnswerOption = ({id, name, icon, text, className, onChange, disabled, checked}) => {
    return (
        <div className={`answer-option ${className || ''}`}>
            <input type="radio" id={id} name={name} onChange={onChange} disabled={disabled} checked={checked} />
            <label htmlFor={id} className='answer-option-content flex flex-align-center'>
                <div className="icon">
                    {icon || ''}
                </div>
                <div className='answer-option-text'>
                    <p>{text}</p>
                </div>
            </label>
        </div>
    );
}

export default AnswerOption;